import { useTheme } from "@amx/ux-twoui-theming";
import { Stack, StackItem } from "@fluentui/react";
import React from "react";
import { Text } from "../../../../Text/Text";
import { LinkListFooterLink } from "../LinkListFooter";
import { linkListFooterContainerStyle, linkListFooterLabelContainerStyle } from "../LinkListFooter.styles";
import { LinkListFooterDefaultProps } from "../LinkListFooter.types";

export const LinkListFooterDefault: React.FC<LinkListFooterDefaultProps> = ({
    label,
    links: linkList,
    borderRadius = true,
    shadow = true
}) => {
    const theme = useTheme();

    return (
        <Stack
            verticalAlign="center"
            styles={linkListFooterContainerStyle(theme, borderRadius, shadow)}
        >
            <Stack
                wrap={true}
                horizontal={true}
                style={{
                    margin: "9px 0 9px 0"
                }}
            >
                {label && (
                    <Stack
                        horizontal={true}
                        styles={linkListFooterLabelContainerStyle()}
                    >
                        <Text variant="bodySecondaryText">
                            {label}
                        </Text>
                    </Stack>
                )}
                <Stack
                    horizontal={true}
                    tokens={{
                        childrenGap: "0 16",
                    }}
                    wrap={linkList.length === 1 ? false : true}
                >
                    {linkList.map((link, index) => (
                        <StackItem key={index}>
                            <LinkListFooterLink {...link} />
                        </StackItem>
                    ))}
                </Stack>
            </Stack>
        </Stack >
    );
};
